export enum PatientOverviewTabOption {
  PreviousAncVisits = "previous-anc-visits",
  History = "history",
  Invoices = "invoices",
}
